
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/design-resources/material-ui-for-figma",
      function () {
        return require("private-next-pages/material-ui/design-resources/material-ui-for-figma.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/design-resources/material-ui-for-figma"])
      });
    }
  